export const columnHeaderStyles =
  'tw-p-3 tw-bg-blue-200 tw-text-grey-800 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300 tw-text-center tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis';
